import React from 'react';
import { Field } from 'react-final-form';
import NumberInput from '../NumberInput';

const NumberField = ({ name, validate, ...restProps }) => (
  <Field name={name} validate={validate} render={({ input }) => <NumberInput {...input} {...restProps} />} />
);

export default NumberField;
